import React from 'react';
import './SlotSchedulerResponseMessage.scss';

const ResponseMessage = ({ title, description, children }) => {
  return (
    <div className="response-message">
      <p className="main-text">{title}</p>
      <p className="sub-text">{description}</p>
      {children}
    </div>
  );
};

export default ResponseMessage;
